module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-340.477ffe1.woff2";